import { z } from "zod";

export type LinkOutcome = "failed" | "rateLimited" | "sent";

const sentSchema = z.object({ status: z.literal("sent") });

const tooManyRequests = 429;
const firstServerError = 500;

// WHY: the function only adds the page's language; unreachable, down or garbled, GoTrue is asked directly instead.
export const functionOutcome = (status: number | null, body: unknown): LinkOutcome | "direct" => {
  if (status === null || status >= firstServerError) {
    return "direct";
  }
  if (status === tooManyRequests) {
    return "rateLimited";
  }
  if (status >= 200 && status < 300) {
    return sentSchema.safeParse(body).success ? "sent" : "direct";
  }
  return "failed";
};
